import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=91618b86"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.103.0__lodash@4_a333b0541c6c7e62171946e4b36a8998/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports